//import 'ol/ol.css';
import * as toastr from "toastr";
import { Utilities, ModalAction } from '../Utility/Utilities';
import { Photos } from '../Photos/Photos';
import { UserDefinedFields } from '../UserDefinedFields/UserDefinedFields';
import { IAPIResult, ICAMSKey, TextPack } from "../Models/UtilityModels";
import * as events from '../Bus/Bus';
import { ModalPrompts, PredefinedModalEnum } from "../Utility/ModalPrompts";


// Exports
export type routeConditionCreateCallback = (result: Boolean, data: ICAMSKey) => any;
export type routeConditionEditCallback = (result: Boolean, data: ICAMSKey) => any;

// List of Jquery controls used in this class
enum jqc {
    placeholder_for_modals = '#placeholder-for-modals'
}

export class Entity_RouteCondition {

    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private initialised: boolean = false;
    private photos: Photos = new Photos();

    // ----------------------------------------------------------- //
    //Constructor
    public constructor() {
        this.initEvents();
    }

    private initEvents = (): void => {
        
    }

    public openConditionCreatePanel = (data: ICAMSKey, callback: routeConditionCreateCallback, isPath: boolean = false): void => {
        const self = this;

        let formUrl, submitUrl;
        formUrl = window.G_SITEFOLDERNAME + '/Route/RouteConditionCreateView';
        submitUrl = '/Route/AddRouteCondition';

        if (isPath == true) formUrl = '/Route/PathConditionCreateView';

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(formUrl, { code: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#routeConditionCreateModal', ModalAction.Create);

            //$('#routeConditionCreateActivityBtn').on('click', function () { self.showActivityInPopover($(this), data); });
            ($('#routeConditionCreateConditionTable') as any).bootstrapTable();

            // Get form validation
            Utilities.InitFormValidation($("#routeConditionCreateForm"));

            //initialise photo uploader
            self.photos.setupUploader('#routeConditionCreateModal');

            // Create Tables
            ($('#routeConditionCreate_LinkedFurnitureTable') as any).bootstrapTable();
            ($('#routeConditionCreate_LinkedIssuesTable') as any).bootstrapTable();

            $('#routeConditionCreate_LinkedIssuesTable [data-issueref]').on('click', function () {
                const linkdata: ICAMSKey = $(this).data("issueref");
                events.bus.publish(events.eventOpenMaintEditPanel(linkdata));
                Utilities.GetModal('#routeConditionCreateModal', ModalAction.Hide);
            });

            $('#routeConditionCreate_LinkedFurnitureTable [data-infraref]').on('click', function () {
                const linkdata: ICAMSKey = $(this).data("infraref");
                events.bus.publish(events.eventOpenInfraEditPanel([linkdata, null]));
                Utilities.GetModal('#routeConditionCreateModal', ModalAction.Hide);
            });

            $('#routeConditionCreateSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#routeConditionCreateForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#routeConditionCreateModal .modal-content"));
                let formData = new FormData(<any>$('#routeConditionCreateForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitUrl,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Added condition!');
                                UserDefinedFields.SaveUDFFieldsAtServer($('#routeConditionCreateForm'), '/Route/UpdateRouteConditionUserFields', parseInt(result.code));
                                // Re-open the entity form
                                Utilities.GetModal('#routeConditionCreateModal', ModalAction.Hide);
                                if (callback != null) callback(true, data);
                            }
                            else {
                                toastr.error('Failed to add condition!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            toastr.error('Failed to add condition!');
                        }
                        finally {
                            Utilities.UnBlockUI($("#routeConditionCreateModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#routeConditionCreateCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#routeConditionCreateModal', ModalAction.Hide);
                if (callback != null) callback(false, null);
            });

            $('#routeConditionCreateCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#routeConditionCreateModal', ModalAction.Hide);
                if (callback != null) callback(false, null);
            });
        });
    }

    public openConditionEditPanel = (data: ICAMSKey, callback: routeConditionEditCallback): void => {
        const self = this;

        let formUrl, submitUrl;
        formUrl = window.G_SITEFOLDERNAME + '/Route/RouteConditionEditView';
        submitUrl = '/Route/UpdateRouteCondition';

        Utilities.BlockUI();
        $('#placeholder-for-modals').load(formUrl, { routeConditionID: data.code }, function (response, status, xhr) {
            if (xhr.status === 401) {//redirect to login in unauthorised
                window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
            }
            Utilities.UnBlockUI();
            Utilities.GetModal('#routeConditionEditModal', ModalAction.Create);
            //$('#routeConditionEditActivityBtn').on('click', function () { self.showActivityInPopover($(this), data); });

            //initialise photo uploader
            self.photos.setupUploader('#routeConditionEditModal');

            // Create Tables
            ($('#routeConditionEdit_LinkedFurnitureTable') as any).bootstrapTable();
            ($('#routeConditionEdit_LinkedIssuesTable') as any).bootstrapTable();

            // Get form validation
            Utilities.InitFormValidation($("#routeConditionEditForm"));

            $('#routeConditionEdit_LinkedIssuesTable [data-issueref]').on('click', function () {               
            });

            $('#routeConditionEdit_LinkedFurnitureTable [data-infraref]').on('click', function () {              
                
            });
            // ******************************************************************************
            // Route Condition Linked Furniture Table Click Events
            var table: any = Utilities.GetControl('#routeConditionEdit_LinkedFurnitureTable');
            table.bootstrapTable(); 
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "code") {
                    var linkdata: ICAMSKey = $element.find("[data-infraref]").data("infraref");
                    events.bus.publish(events.eventOpenInfraEditPanel([linkdata, function () {
                        self.openConditionEditPanel(data,callback);
                    }]));
                    Utilities.GetModal('#routeConditionEditModal', ModalAction.Hide);
                }
            });
            // ******************************************************************************
            // Route Condition Linked Issues Table Click Events
            var table: any = Utilities.GetControl('#routeConditionEdit_LinkedIssuesTable');
            table.bootstrapTable(); 
            table.on('click-cell.bs.table', function (e, field, value, row, $element) {
                if (field == "feature") {                    
                    var issuedata: ICAMSKey = $element.find("[data-issueref]").data("issueref");
                    events.bus.publish(events.eventOpenMaintEditPanel(issuedata));
                    Utilities.GetModal('#routeConditionEditModal', ModalAction.Hide);
                }
            });

            $('#routeConditionEditSubmitBtn').on('click', function (evt) {
                evt.preventDefault();

                // Validate
                let form: any = $('#routeConditionEditForm');
                if (Utilities.CheckFormValidation(form)==false) return;

                Utilities.BlockUI($("#routeConditionEditModal .modal-content"));
                let formData = new FormData(<any>$('#routeConditionEditForm')[0]);
                $.ajax({
                    type: "POST",
                    processData: false,
                    contentType: false,
                    enctype: 'multipart/form-data',
                    url: submitUrl,
                    data: formData,
                    success: function (result: IAPIResult) {
                        try {
                            if (result.success == true) {
                                toastr.info('Updated condition!');
                                UserDefinedFields.SaveUDFFieldsAtServer($('#routeConditionEditForm'), '/Route/UpdateRouteConditionUserFields', parseInt(result.code));
                                // Re-open the entity form
                                Utilities.GetModal('#routeConditionEditModal', ModalAction.Hide);
                                if (callback != null) callback(true, data);
                            }
                            else {
                                toastr.error('Failed to update condition!');
                            }
                        }
                        catch (err) {
                            console.log(err);
                            toastr.error('Failed to update condition!');
                        }
                        finally {
                            Utilities.UnBlockUI($("#routeConditionEditModal .modal-content"));
                        }
                    }
                }).fail(function (xhr) {
                    if (xhr.status === 401) {//redirect to login in unauthorised
                        window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                    }
                });
            });

            $('#routeConditionEditCancelBtn').on('click', function (evt) {
                Utilities.GetModal('#routeConditionEditModal', ModalAction.Hide);
                if (callback != null) callback(false, null);
            });

            $('#routeConditionEditCloseBtn').on('click', function (evt) {
                Utilities.GetModal('#routeConditionEditModal', ModalAction.Hide);
                if (callback != null) callback(false, null);
            });

            $('#routeConditionEditDeleteBtn').on('click', function (evt) {
                self.deleteCondition(data, callback);
            });
        });
    }

    public deleteCondition = (data: ICAMSKey, callback: Function): void => {
        const self = this;
        ModalPrompts.OpenPrompt({ promptYesNoPredefinedEnum: PredefinedModalEnum.Delete }).then(r => {
            if (r.yes == true) {
                doDelete();
            }
            else {
            }
        }).catch(e => { });

        function doDelete() {
            Utilities.BlockUI();
            $.post('/Route/DeleteRouteCondition', data,
                function (result: IAPIResult) {
                    Utilities.UnBlockUI();
                    try {
                        if (result.success == true) {
                            Utilities.GetModal('#routeConditionEditModal', ModalAction.Hide);
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteComplete" }]).then(m => { if (m.success == true) toastr.info(m.data[0].value); });
                        }
                        else {
                            Utilities.GetTranslations([{ textPack: TextPack.OtherPagesTextPack, key: "Toast_DeleteFailed" }]).then(m => { if (m.success == true) toastr.error(m.data[0].value); });
                        }
                        
                    }
                    catch (err) {
                        console.log(err);
                    }
                    finally {
                        if (callback != null) callback(null);
                    };
                }
            ).fail(function (xhr) {
                if (xhr.status === 401) {//redirect to login in unauthorised
                    window.location.href = window.G_SITEFOLDERNAME +'/account/login?ReturnUrl=' + encodeURIComponent(window.location.pathname);
                }
            });
        }
    }
}




